// Theme configuration for Parcel Delivery Platform

// Base light theme (used as foundation for other themes)
const baseLightTheme = {
  // Primary colors
  primary: {
    50: '#eff6ff',
    100: '#dbeafe', 
    200: '#bfdbfe',
    300: '#93c5fd',
    400: '#60a5fa',
    500: '#3b82f6',
    600: '#2563eb',
    700: '#1d4ed8',
    800: '#1e40af',
    900: '#1e3a8a',
    950: '#172554'
  },
  
  // Secondary colors
  secondary: {
    50: '#f8fafc',
    100: '#f1f5f9',
    200: '#e2e8f0',
    300: '#cbd5e1',
    400: '#94a3b8',
    500: '#64748b',
    600: '#475569',
    700: '#334155',
    800: '#1e293b',
    900: '#0f172a',
    950: '#020617'
  },
  
  // Success colors
  success: {
    50: '#f0fdf4',
    100: '#dcfce7',
    200: '#bbf7d0',
    300: '#86efac',
    400: '#4ade80',
    500: '#22c55e',
    600: '#16a34a',
    700: '#15803d',
    800: '#166534',
    900: '#14532d',
    950: '#052e16'
  },
  
  // Warning colors
  warning: {
    50: '#fffbeb',
    100: '#fef3c7',
    200: '#fde68a',
    300: '#fcd34d',
    400: '#fbbf24',
    500: '#f59e0b',
    600: '#d97706',
    700: '#b45309',
    800: '#92400e',
    900: '#78350f',
    950: '#451a03'
  },
  
  // Error colors
  error: {
    50: '#fef2f2',
    100: '#fee2e2',
    200: '#fecaca',
    300: '#fca5a5',
    400: '#f87171',
    500: '#ef4444',
    600: '#dc2626',
    700: '#b91c1c',
    800: '#991b1b',
    900: '#7f1d1d',
    950: '#450a0a'
  },
  
  // Neutral colors
  neutral: {
    0: '#ffffff',
    50: '#fafafa',
    100: '#f5f5f5',
    200: '#e5e5e5',
    300: '#d4d4d4',
    400: '#a3a3a3',
    500: '#737373',
    600: '#525252',
    700: '#404040',
    800: '#262626',
    900: '#171717',
    950: '#0a0a0a'
  },
  
  // Semantic colors
  background: '#ffffff',
  surface: '#ffffff',
  card: '#ffffff',
  text: {
    primary: '#0f172a',
    secondary: '#475569',
    tertiary: '#64748b',
    inverse: '#ffffff'
  },
  
  // Border colors
  border: {
    light: '#e2e8f0',
    medium: '#cbd5e1',
    dark: '#94a3b8'
  },
  
  // Shadow colors
  shadow: {
    sm: 'rgba(0, 0, 0, 0.05)',
    md: 'rgba(0, 0, 0, 0.1)',
    lg: 'rgba(0, 0, 0, 0.15)',
    xl: 'rgba(0, 0, 0, 0.2)'
  }
};

export const themes = {
  light: {
    ...baseLightTheme,
    primary: {
      50: '#f0f4ff',
      100: '#e0e9ff',
      200: '#c7d9ff',
      300: '#a4c4ff',
      400: '#819fff',
      500: '#081c5a', // Your primary color
      600: '#061548',
      700: '#041236',
      800: '#020f24',
      900: '#010c18',
      950: '#00060c'
    },
    secondary: {
      50: '#fef7f7',
      100: '#fdeeee',
      200: '#fadddd',
      300: '#f7c7c7',
      400: '#f5b1b1',
      500: '#f76806', // Your secondary color
      600: '#e65505',
      700: '#d64204',
      800: '#c63003',
      900: '#b61d02',
      950: '#8b1501'
    }
  },
  
  dark: {
    ...baseLightTheme,
    // Same background as light theme - white
    background: '#ffffff',
    surface: '#f8fafc',
    card: '#ffffff',
    text: {
      primary: '#0f172a',
      secondary: '#475569',
      tertiary: '#64748b',
      inverse: '#ffffff'
    },
    border: {
      light: '#e2e8f0',
      medium: '#cbd5e1',
      dark: '#94a3b8'
    },
    neutral: {
      50: '#f8fafc',
      100: '#f1f5f9',
      200: '#e2e8f0',
      300: '#cbd5e1',
      400: '#94a3b8',
      500: '#64748b',
      600: '#475569',
      700: '#334155',
      800: '#1e293b',
      900: '#0f172a',
      950: '#020617'
    },
    // Reversed colors for dark mode - Orange becomes primary, Blue becomes secondary
    primary: {
      50: '#fef7f7',
      100: '#fdeeee',
      200: '#fadddd',
      300: '#f7c7c7',
      400: '#f5b1b1',
      500: '#f76806', // Your secondary color becomes primary in dark mode
      600: '#e65505',
      700: '#d64204',
      800: '#c63003',
      900: '#b61d02',
      950: '#8b1501'
    },
    
    secondary: {
      50: '#f0f4ff',
      100: '#e0e9ff',
      200: '#c7d9ff',
      300: '#a4c4ff',
      400: '#819fff',
      500: '#081c5a', // Your primary color becomes secondary in dark mode
      600: '#061548',
      700: '#041236',
      800: '#020f24',
      900: '#010c18',
      950: '#00060c'
    }
  },
    
    // Success colors (same in both modes)
    success: {
      50: '#052e16',
      100: '#14532d',
      200: '#166534',
      300: '#15803d',
      400: '#16a34a',
      500: '#22c55e',
      600: '#4ade80',
      700: '#86efac',
      800: '#bbf7d0',
      900: '#dcfce7',
      950: '#f0fdf4'
    },
    
    // Warning colors (same in both modes)
    warning: {
      50: '#451a03',
      100: '#78350f',
      200: '#92400e',
      300: '#b45309',
      400: '#d97706',
      500: '#f59e0b',
      600: '#fbbf24',
      700: '#fcd34d',
      800: '#fde68a',
      900: '#fef3c7',
      950: '#fffbeb'
    },
    
    // Error colors (same in both modes)
    error: {
      50: '#450a0a',
      100: '#7f1d1d',
      200: '#991b1b',
      300: '#b91c1c',
      400: '#dc2626',
      500: '#ef4444',
      600: '#f87171',
      700: '#fca5a5',
      800: '#fecaca',
      900: '#fee2e2',
      950: '#fef2f2'
    },
    
    // Neutral colors (inverted for dark mode)
    neutral: {
      0: '#000000',
      50: '#0a0a0a',
      100: '#171717',
      200: '#262626',
      300: '#404040',
      400: '#525252',
      500: '#737373',
      600: '#a3a3a3',
      700: '#d4d4d4',
      800: '#e5e5e5',
      900: '#f5f5f5',
      950: '#fafafa'
    },
    
    // Semantic colors (dark mode)
    background: '#0f172a',
    surface: '#1e293b',
    card: '#1e293b',
    text: {
      primary: '#f8fafc',
      secondary: '#cbd5e1',
      tertiary: '#94a3b8',
      inverse: '#0f172a'
    },
    
    // Border colors (dark mode)
    border: {
      light: '#334155',
      medium: '#475569',
      dark: '#64748b'
    },
    
    // Shadow colors (dark mode)
    shadow: {
      sm: 'rgba(0, 0, 0, 0.3)',
      md: 'rgba(0, 0, 0, 0.4)',
      lg: 'rgba(0, 0, 0, 0.5)',
      xl: 'rgba(0, 0, 0, 0.6)'
    },
  // },
  
  // Additional theme presets
  blue: {
    // Blue-themed variant
    ...baseLightTheme,
    primary: {
      50: '#f0f9ff',
      100: '#e0f2fe',
      200: '#bae6fd',
      300: '#7dd3fc',
      400: '#38bdf8',
      500: '#0ea5e9',
      600: '#0284c7',
      700: '#0369a1',
      800: '#075985',
      900: '#0c4a6e',
      950: '#082f49'
    }
  },
  
  green: {
    // Green-themed variant
    ...baseLightTheme,
    primary: {
      50: '#f0fdf4',
      100: '#dcfce7',
      200: '#bbf7d0',
      300: '#86efac',
      400: '#4ade80',
      500: '#22c55e',
      600: '#16a34a',
      700: '#15803d',
      800: '#166534',
      900: '#14532d',
      950: '#052e16'
    }
  }
};

// Default theme
export const defaultTheme = 'light';

// Theme type definitions (commented out for JS compatibility)
// export type ThemeName = keyof typeof themes;
// export type ThemeColors = typeof themes.light;
